module.exports = __webpack_public_path__ + "img/28-1.461e2f3b.jpg";